/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="dialogoutcome.ts" />
/// <reference path="bootstrapsize.ts" />

module App.Common {

	export class ModalDialogConfig {

		public title: string;

		public scope: angular.IScope;

		public component: string;

		public templateUrl: string;

		public template: string;

		public controller: string;

		public canDismissWithBackdropClick = false;

		public canDismissWithEscapeKey = false;

		public size = BootstrapSize.Small;

		public screenMode = ScreenMode.Edit;

		public onClose: <TResult>(result: TResult) => void;

		public onClosing: <TResult>(result: TResult) => angular.IPromise<any>;

		public onDismiss: <TResult>(result: TResult) => void;

		public onDismissing: <TResult>(result: TResult) => angular.IPromise<any>;

	}

}